module.exports = __webpack_public_path__ + "static/link.dd52eea1.png";